import React from "react";

const TotalSection = ({
  vat,
  total,
}: {
  total: { label: string; amount: React.ReactNode };
  vat?: { label: React.ReactNode; amount: React.ReactNode };
}) => (
  <div className="hidden text-sm sm:flex sm:justify-between">
    <div>
      <p>{total.label}</p>
      {vat && <p className="text-sm text-tertiary-8">{vat.label}</p>}
    </div>
    <div className="text-right font-bold">
      <p>{total.amount}</p>
      {vat && <p className="text-tertiary-8">{vat.amount}</p>}
    </div>
  </div>
);

export default TotalSection;
